//shared containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '/containers-m/';
import { Logos, logos_list } from '@/containers-ai/Logos';
import { Proof, proofOutcomes } from '@/containers-ai/Proof';

//containers
import {
  Hero,
  Lineup,
  LiveInProduction,
  ScenarioTheater,
  AgenticWorkflow,
  Rails,
  EndCTA,
} from './containers/index';

//styles
import { PageWrapper, AIGlobalStyle } from './AI.styles';
import { LifecycleRail } from '@/containers-ai/LifecycleRail';

function AI({ lifecycle_content }) {
  return (
    <PageWrapper>
      <AIGlobalStyle />
      <Navigation theme="dark" />
      <Hero />
      <Logos logos={logos_list} />
      <Lineup />
      <LiveInProduction />
      <AgenticWorkflow />
      <EndCTA variant="top" />
      <Rails />
      <ScenarioTheater />
      <Proof outcomes={proofOutcomes} />
      <LifecycleRail lifecycle_content={lifecycle_content} />
      <EndCTA variant="bottom" />
      <Footer />
    </PageWrapper>
  );
}

export default AI;
export { AI };
